import { fcaFastApi, fcaGateWay, fcaReportGateway } from "../../services/authorizationService";
import * as serviceEndpoints from "../../config/serviceEndPoints";
import { isEnabled } from "../../services/featureFlags";

// Filter dropdowns migrated to FastAPI (FCA-6774 slice 1; clients added by
// slice 3 / FCA-6895). Keys without a FastAPI path (users) stay on legacy.
export const getSmartChartMasterFilterDropDown = (key, params) => {
    const fastApiPath = serviceEndpoints.smartChartEndPoints.masterFiltersFastApi[key];
    return isEnabled("migrate_smartchart_filters") && fastApiPath
        ? fcaFastApi.get(fastApiPath, { params })
        : fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.masterFilters[key]}`, { params });
};
export const exportSmartChartData = params => fcaReportGateway.post(`${serviceEndpoints.smartChartEndPoints.exportSmartChartData}`, params);
export const saveSmartChartData = params => fcaReportGateway.post(`${serviceEndpoints.smartChartEndPoints.saveSmartChartData}`, params);
// Export-data LIST migrated to FastAPI (FCA-6774 slice 2 / FCA-6894);
// write actions (soft-delete, favourite) stay on the legacy gateway.
export const getExportedSmartChartList = params =>
    isEnabled("migrate_smartchart_filters")
        ? fcaFastApi.get(serviceEndpoints.smartChartEndPoints.getExportedSmartChartListFastApi, { params })
        : fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getExportedSmartChartList}`, { params });
export const deleteSmartChartReport = (id, user_id) =>
    fcaReportGateway.patch(`${serviceEndpoints.smartChartEndPoints.deleteSmartChartReport}${id}/soft-delete/`, { user_id });
export const uploadDocsForSmartReport = params => fcaReportGateway.post(`${serviceEndpoints.smartChartEndPoints.uploadDocsForSmartReport}`, params);
export const getUploadedDocList = params => fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getUploadedDocList}`, { params });
export const updateSmartReportData = (id, params) =>
    fcaReportGateway.patch(`${serviceEndpoints.smartChartEndPoints.updateSmartReportData}${id}/`, params);
// Template-settings sync reads migrated to FastAPI (FCA-6774 slice 3 / FCA-6895).
export const getTemplatePropertiesList = params =>
    isEnabled("migrate_smartchart_filters")
        ? fcaFastApi.get(serviceEndpoints.smartChartEndPoints.getTemplatePropertiesListFastApi, { params })
        : fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getTemplatePropertiesList}`, { params });
export const getTaskManagerList = params => fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getTaskManager}`, { params });
export const getSmartChartLog = params => fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getSmartChartLogsData}`, { params });
export const updateEndTaskManager = params => fcaReportGateway.post(`${serviceEndpoints.smartChartEndPoints.endTaskManager}`, params);

export const clearAllTaskManager = id => {
    return fcaReportGateway.delete(`${serviceEndpoints.smartChartEndPoints.clearTaskManager}`, {
        data: { client_id: id }
    });
};

export const deleteTaskManagerById = id => fcaReportGateway.delete(`${serviceEndpoints.smartChartEndPoints.getTaskManager}${id}/`);
export const getTemplateList = params =>
    isEnabled("migrate_smartchart_filters")
        ? fcaFastApi.get(serviceEndpoints.smartChartEndPoints.getTemplateListFastApi, { params })
        : fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getTemplateList}`, { params });
export const deleteUserDocs = params => fcaReportGateway.delete(`${serviceEndpoints.smartChartEndPoints.deleteUserDocs}`, { params });
export const getClientDropDownData = params =>
    isEnabled("migrate_smartchart_filters")
        ? fcaFastApi.get(serviceEndpoints.smartChartEndPoints.getClientDropDownDataFastApi, { params })
        : fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getClientDropDownData}`, { params });
export const updateDocOrder = params => fcaReportGateway.post(`${serviceEndpoints.smartChartEndPoints.updateDocOrder}`, params);
export const updateUserDocData = (id, params) => fcaReportGateway.patch(`${serviceEndpoints.smartChartEndPoints.updateUserDocData}${id}/`, params);
export const updateSmartChartProperty = (id, params) =>
    fcaReportGateway.patch(`${serviceEndpoints.smartChartEndPoints.updateSmartChartProperty}${id}/`, params);
// Property sync reads (list / core_report / retrieve) migrated to FastAPI
// (FCA-6774 slice 2 / FCA-6894); property writes stay on the legacy gateway.
export const getSmartChartPropertyList = (params, type) => {
    if (isEnabled("migrate_smartchart_filters")) {
        return type === "core-report"
            ? fcaFastApi.get(serviceEndpoints.smartChartEndPoints.getCoreReportPropertyListFastApi, { params })
            : fcaFastApi.get(serviceEndpoints.smartChartEndPoints.getSmartChartPropertyListFastApi, { params });
    }
    return type === "core-report"
        ? fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getCoreReportPropertyList}`, { params })
        : fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getSmartChartPropertyList}`, { params });
};
export const getSmartChartPropertySourceTemplete = (id, params) => {
    return isEnabled("migrate_smartchart_filters")
        ? fcaFastApi.get(`${serviceEndpoints.smartChartEndPoints.getSmartChartPropertyByIdFastApi}/${id}`, { params })
        : fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getSmartChartPropertyList}${id}/`, { params });
};
export const getSmartChartPropertyById = (id, params) =>
    isEnabled("migrate_smartchart_filters")
        ? fcaFastApi.get(`${serviceEndpoints.smartChartEndPoints.getSmartChartPropertyByIdFastApi}/${id}`, { params })
        : fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getSmartChartPropertyById}${id}/`, { params });
export const deleteSmartChartReportTemplate = (params, type) =>
    type === "core-report"
        ? fcaReportGateway.post(`${serviceEndpoints.smartChartEndPoints.deleteCoreReportTemplate}`, params)
        : fcaReportGateway.post(`${serviceEndpoints.smartChartEndPoints.deleteSmartChartReportTemplate}`, params);
export const assignImagesToSmartCharts = params => fcaReportGateway.post(`${serviceEndpoints.smartChartEndPoints.assignImagesToSmartCharts}`, params);
export const lockSmartChartTemplate = params => fcaReportGateway.post(`${serviceEndpoints.smartChartEndPoints.lockSmartChartTemplate}`, params);
export const addSmartChartToFavorites = params => fcaReportGateway.post(`${serviceEndpoints.smartChartEndPoints.addSmartChartToFavorites}`, params);
export const getUsersByClient = params => fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getUsersByClient}`, { params });
export const assignFavoriteToUsers = params => fcaReportGateway.post(`${serviceEndpoints.smartChartEndPoints.assignFavoriteToUsers}`, params);
export const getExportPropertyListForSmartChartRecom = params =>
    fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getExportPropertyListForSmartChartRecom}`, { params });
export const getExportTemplateListForSmartChartRecom = params =>
    fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getExportTemplateListForSmartChartRecom}`, { params });
export const getExportSettingsForSmartChartRecom = (params, type) => {
    if (type === "buildings" || type === "additions")
        return fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getExportSettingsForSmartChart}`, { params });
    else return fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getExportSettingsForSmartChartRecom}`, { params });
};
export const saveExportSettingsForSmartChartRecom = (params, type) => {
    if (type === "buildings" || type === "additions")
        return fcaReportGateway.post(`${serviceEndpoints.smartChartEndPoints.saveExportSettingsForSmartChart}`, params);
    else return fcaReportGateway.post(`${serviceEndpoints.smartChartEndPoints.saveExportSettingsForSmartChartRecom}`, params);
};
export const createSkeletonFromTemplate = params =>
    fcaReportGateway.post(`${serviceEndpoints.smartChartEndPoints.createSkeletonFromTemplate}`, params);
export const createReportFromCoreReport = params =>
    fcaReportGateway.post(`${serviceEndpoints.smartChartEndPoints.createReportFromCoreReport}`, params);
export const updateSkeletonFromTemplate = (id, params) =>
    fcaReportGateway.patch(`${serviceEndpoints.smartChartEndPoints.saveCoreReportData}${id}/`, params);
// user-fields geo-hierarchy reads migrated to FastAPI (FCA-6774 slice 2 / FCA-6894).
export const getCaColumns = (params, type) =>
    isEnabled("migrate_smartchart_filters")
        ? fcaFastApi.get(serviceEndpoints.smartChartEndPoints.getCaColumnsFastApi[type], { params })
        : fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getCaColumns[type]}`, { params });
export const getMultiCaColumns = (params, type) =>
    isEnabled("migrate_smartchart_filters")
        ? fcaFastApi.post(serviceEndpoints.smartChartEndPoints.getCaColumnsFastApi[type], params)
        : fcaReportGateway.post(`${serviceEndpoints.smartChartEndPoints.getCaColumns[type]}`, params);
export const getSmartchartAssetExportSettings = params =>
    fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getExportSettingsForSmartChartAsset}`, { params });
export const getExportPropertyListForSmartChartAsset = params =>
    fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getExportPropertyListForSmartChartAsset}`, { params });
export const getExportTemplateListForSmartChartAsset = params =>
    fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getExportTemplateListForSmartChartAsset}`, { params });
export const saveExportSettingsForSmartChartAsset = params =>
    fcaReportGateway.post(`${serviceEndpoints.smartChartEndPoints.saveExportSettingsForSmartChartAsset}`, params);
export const getBuildingTrades = params => fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getBuildingTrades}`, { params });
export const getAsposeStatusCheck = params => fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getAsposeStatusCheck}`, { params });
export const getDefaultYearBreakdownProperty = params =>
    fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getDefaultYearBreakdownProperty}`, { params });
export const patchYearBreakdownProperty = params =>
    fcaReportGateway.put(`${serviceEndpoints.smartChartEndPoints.patchYearBreakdownProperty}`, params);

export const getPreviewDoc = params =>
    fcaReportGateway.post(`${serviceEndpoints.smartChartEndPoints.getDocPreview}`, params, {
        method: "POST",
        responseType: "blob"
    });
export const getDefaultBBIProperties = params => fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getDefaultBBIProperties}`, { params });
export const getDefaultProperties = (params, key) => {
    if (key === "bsi") {
        return fcaReportGateway.get(serviceEndpoints.smartChartEndPoints.getDefaultBSIProperties, { params });
    } else {
        return fcaReportGateway.get(serviceEndpoints.smartChartEndPoints.getDefaultBAIProperties, { params });
    }
};
export const getHeaderKeyList = params => fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getHeaderKeyList}`, { params });
export const getExecutiveSummaryBandTiles = params =>
    fcaReportGateway.get(`${serviceEndpoints.smartChartEndPoints.getExecutiveSummaryBandTiles}`, { params });

export const saveExecutiveSummaryTileToBuilding = body =>
    fcaFastApi.patch(`${serviceEndpoints.smartChartEndPoints.saveExecutiveSummaryTileToBuilding}`, body);
